import styles from "./custom.module.css";
import DOMPurify from "dompurify";
const Custom = ({textData}) => {
  return (
    <div className={styles.ctn}>
      <h1             dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData["text48"]),
            }}></h1>
      <div className={styles.contentItem}>
        <div className={styles.textBox}>
          <h3             dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData["text49"]),
            }}></h3>
          <h5 
                      dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData["text50"]),
            }}>
          </h5>
        </div>

        <img
          src="https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-detail-media-9-1.jpg"
          alt="WEEBILL 3"
        />
      </div>

      <div className={styles.contentItem}>
        <img
          src="https://bucket.zhiyun-tech.com/detail/wbl3/wbl3-detail-media-9-2.jpg"
          alt="WEEBILL 3"
        />
        <div className={styles.textBox}>
          <h3             dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData["text51"]),
            }}></h3>
          <h5             dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData["text52"]),
            }}>
          </h5>
        </div>
      </div>
    </div>
  );
};

export default Custom;
